import React, { useState } from 'react';
import { FolderIcon, XIcon, CheckIcon } from 'lucide-react';
export function FileMoveModal({
  file,
  isOpen,
  onClose,
  onMove
}) {
  const [selectedDestination, setSelectedDestination] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // Sample destinations - in a real app, these would come from an API
  const destinations = [{
    id: 'dest-1',
    name: 'Finance Documents',
    path: '/finance'
  }, {
    id: 'dest-2',
    name: 'HR Documents',
    path: '/hr'
  }, {
    id: 'dest-3',
    name: 'Marketing Materials',
    path: '/marketing'
  }, {
    id: 'dest-4',
    name: 'Project Files',
    path: '/projects'
  }, {
    id: 'dest-5',
    name: 'Legal Documents',
    path: '/legal'
  }];
  const handleMove = () => {
    if (!selectedDestination) return;
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      onMove(selectedDestination);
      setIsLoading(false);
    }, 500);
  };
  if (!isOpen) return null;
  return <div className="fixed z-10 inset-0 overflow-y-auto" data-id="element-6027">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-6028">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true" onClick={onClose} data-id="element-6029">
          <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-6030"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-6031">
          &#8203;
        </span>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-6032">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-6033">
            <div className="sm:flex sm:items-start" data-id="element-6034">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100 sm:mx-0 sm:h-10 sm:w-10" data-id="element-6035">
                <FolderIcon className="h-6 w-6 text-indigo-600" data-id="element-6036" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left" data-id="element-6037">
                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title" data-id="element-6038">
                  Move File
                </h3>
                <div className="mt-2" data-id="element-6039">
                  <p className="text-sm text-gray-500" data-id="element-6040">
                    Select a destination for "{file.name}"
                  </p>
                </div>
                <div className="mt-4" data-id="element-6041">
                  <div className="space-y-2" data-id="element-6042">
                    {destinations.map(dest => <label key={dest.id} className={`relative block p-4 rounded-lg border cursor-pointer focus:outline-none ${selectedDestination === dest.path ? 'bg-indigo-50 border-indigo-500' : 'border-gray-300 hover:border-gray-400'}`} data-id="element-6043">
                        <input type="radio" name="destination" value={dest.path} className="sr-only" onChange={e => setSelectedDestination(e.target.value)} checked={selectedDestination === dest.path} data-id="element-6044" />
                        <div className="flex items-center" data-id="element-6045">
                          <div className="mr-3" data-id="element-6046">
                            <FolderIcon className={`h-5 w-5 ${selectedDestination === dest.path ? 'text-indigo-500' : 'text-gray-400'}`} data-id="element-6047" />
                          </div>
                          <div data-id="element-6048">
                            <p className={`text-sm font-medium ${selectedDestination === dest.path ? 'text-indigo-900' : 'text-gray-900'}`} data-id="element-6049">
                              {dest.name}
                            </p>
                            <p className={`text-xs ${selectedDestination === dest.path ? 'text-indigo-700' : 'text-gray-500'}`} data-id="element-6050">
                              {dest.path}
                            </p>
                          </div>
                          {selectedDestination === dest.path && <div className="absolute right-4" data-id="element-6051">
                              <CheckIcon className="h-5 w-5 text-indigo-500" data-id="element-6052" />
                            </div>}
                        </div>
                      </label>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-6053">
            <button type="button" className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm ${isLoading || !selectedDestination ? 'bg-indigo-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'}`} onClick={handleMove} disabled={isLoading || !selectedDestination} data-id="element-6054">
              {isLoading ? 'Moving...' : 'Move File'}
            </button>
            <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={onClose} data-id="element-6055">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>;
}